module.exports = __webpack_public_path__ + "static/media/Galdisa_Blanched Peanuts.d3f38795.pdf";